import { put, select } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';

import * as Actions from '../actions';
import * as Constants from '../constants';
import * as Selectors from '../selectors';

import { AbstractWatcher } from './abstract-watcher';

const DEFAULT_TIMEOUT = 1000 * 60;

const stageLoaded = (status) => {
  return status === Constants.STAGES_LOADING_VALUES.LOADED;
};

export class CreatePage extends AbstractWatcher {
  stages = new Set();

  *runStage(stage, payload, { async = false, timeout = DEFAULT_TIMEOUT } = {}) {
    const {
      [Constants.ABSTRACT_WATCHER_ACTION_SYMBOL]: stageAction,
      [Constants.ABSTRACT_WATCHER_NAME_SYMBOL]: stageName,
    } = stage;

    if (!stageAction || !stageName) {
      throw new Error('Unknown stage');
    }

    this.stages.add(stageName);

    yield put({ payload, type: stageAction });

    if (async) {
      return;
    }

    yield selectWhen(Selectors.selectStageLoading(stageName), stageLoaded, timeout);
  }

  *checkStages({ timeout = DEFAULT_TIMEOUT } = {}) {
    const stages = Array.from(this.stages);

    if (!stages.length) {
      return;
    }

    for (const stage of stages) {
      yield selectWhen(Selectors.selectStageLoading(stage), stageLoaded, timeout);

      const error = yield select(Selectors.selectStageError(stage));
      const { type } = error ?? {};

      if (!type) {
        continue;
      }

      throw error;
    }
  }

  *action(params) {
    const {
      after: afterOption,
      before: beforeOption,
      handler: handlerOption,
      name: nameOption,
    } = this.options;

    try {
      yield* beforeOption(params);
      yield* handlerOption(params, { runStage: this.runStage.bind(this) });
      yield* this.checkStages();
      yield* afterOption(params);
    } catch (error) {
      const payload = AbstractWatcher.errorHandler(error);

      yield put(Actions.updatePagesErrors({ [nameOption]: payload }));
    }
  }
}
